import React from "react";
import { Route, HashRouter as Router, Routes } from "react-router-dom";

import About from "./pages/About.tsx";
import Landing from "./pages/Landing.tsx";
import Projects from "./pages/Projects.tsx";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
      </Routes>
    </Router>
  );
};

export default App;
